import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-warning-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col items-center w-full rounded-lg bg-beige p-6 text-center">
      <p class="text-sm lg:text-base w-full  mx-auto">
        This calculator is custom designed for Atlas Copco Specialty Rental division to provide users with data on the
        carbon footprint of their equipment. The calculation is done according to the Green House Gas protocol.
        Pre-filled data is derived from product performance data and assumptions made based on years of research and
        expertise. Although the calculations are done relying on proven data only, each user's situation is different,
        and these results can not at all be considered guaranteed and can serve only as an indication of what you can
        expect. It does not take into account, nor can it predict any future change in one or more of the criteria used
        for this calculation. If you require exact data or have questions about the results, please contact us for more
        information. Relying on this estimate calculation is at full risk of the customer. In no event can Atlas Copco
        be held liable for any inaccuracy in the calculation of potential savings or any damages or loss suffered by
        relying on this estimate calculation. To the fullest extent allowable under applicable law, we disclaim all
        warranties and conditions, whether express or implied, including any warranties or conditions for any
        merchantability, fitness for a particular use or noninfringement and we do not accept any responsibility for any
        damage or loss caused by the use of this tool. This calculator and its contents are subject to change without
        prior notice. If you require exact data or havequestions about the results, please contact us for more
        information. Read our full Legal Notice for more information:
        https://www.atlascopco.com/privacyportal/en/legal-notice
      </p>
    </div>
  `,
})
export class WarningMessageComponent {}
